import { render, staticRenderFns } from "./OperationsDetails.vue?vue&type=template&id=22d78316&lang=pug&"
import script from "./OperationsDetails.vue?vue&type=script&lang=js&"
export * from "./OperationsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports